// extracted by mini-css-extract-plugin
module.exports = {"activityListItem":"_2lbX6","activityListItemDescription":"_1nX2i","descriptionTextWrapper":"_2QKqY","activityIconWrapper":"_1iYBT","withPadding":"_2vqiy"};